import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const C = { primary:"#f97316", dark:"#ea580c", white:"#ffffff", bg:"#f2f2f7", text:"#1c1c1e", sub:"#6b7280", border:"#e5e7eb" };

function Section({ title, children }) {
  return (
    <div style={{ background:C.white, borderRadius:16, padding:"20px", marginBottom:14, border:`1px solid ${C.border}` }}>
      <div style={{ fontFamily:"'Fraunces',serif", fontWeight:800, fontSize:"1rem", marginBottom:10, color:C.dark }}>{title}</div>
      <div style={{ fontSize:"0.85rem", color:C.sub, lineHeight:1.8 }}>{children}</div>
    </div>
  );
}

export default function ShippingPolicy() {
  const navigate = useNavigate();
  return (
    <div style={{ fontFamily:"'Plus Jakarta Sans',system-ui,sans-serif", background:C.bg, minHeight:"100vh", color:C.text }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,800;9..144,900&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}`}</style>

      <div style={{ background:C.white, borderBottom:`1px solid ${C.border}`, padding:"14px 20px", display:"flex", alignItems:"center", gap:12, position:"sticky", top:0, zIndex:10 }}>
        <button onClick={() => navigate(-1)} style={{ background:"none", border:"none", cursor:"pointer", display:"flex" }}><ArrowLeft size={22} color={C.text}/></button>
        <div style={{ fontFamily:"'Fraunces',serif", fontWeight:900, fontSize:"1.15rem" }}>Shipping & Delivery Policy</div>
      </div>

      <div style={{ maxWidth:640, margin:"0 auto", padding:"24px 20px 48px" }}>

        <div style={{ background:`linear-gradient(135deg,${C.dark},${C.primary})`, borderRadius:16, padding:"20px 24px", marginBottom:20 }}>
          <div style={{ color:"#fff", fontWeight:800, fontSize:"1rem", marginBottom:4 }}>Shipping & Delivery — Quickry</div>
          <div style={{ color:"rgba(255,255,255,0.8)", fontSize:"0.78rem" }}>Last updated: January 2025 | Delivering across Akola</div>
        </div>

        <Section title="1. Delivery Area">
          Quickry currently provides delivery services within <strong style={{ color:C.text }}>Akola city limits, Maharashtra</strong>. We are continuously expanding our delivery zones. Customers outside our serviceable area will be notified at checkout.
        </Section>

        <Section title="2. Delivery Time Estimates">
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:4 }}>
            {[
              { service:"Food Delivery",    time:"30–45 mins" },
              { service:"Grocery",          time:"10–20 mins" },
              { service:"Courier/Pickup",   time:"Same day"   },
              { service:"Medicine",         time:"30–45 mins" },
            ].map(({ service, time }) => (
              <div key={service} style={{ background:"#f8fafc", borderRadius:10, padding:"10px 12px", border:`1px solid ${C.border}` }}>
                <div style={{ fontSize:"0.75rem", color:C.sub, fontWeight:600 }}>{service}</div>
                <div style={{ fontSize:"0.9rem", fontWeight:800, color:C.primary, marginTop:2 }}>{time}</div>
              </div>
            ))}
          </div>
          <br/>
          Delivery times are estimates and may vary due to distance, traffic, weather conditions, or high order volume.
        </Section>

        <Section title="3. Delivery Charges">
          Delivery charges are calculated based on distance and displayed at checkout before payment. Charges typically range from ₹20 to ₹50 depending on the distance.<br/><br/>
          <strong style={{ color:C.text }}>Free Delivery:</strong> Available on orders above ₹199 from select restaurants and stores (as indicated on the platform).
        </Section>

        <Section title="4. Order Tracking">
          Once your order is accepted and a delivery partner is assigned, you can track your order in real-time through the "My Orders" section of the app. Live location tracking of the delivery partner is available once they pick up your order.
        </Section>

        <Section title="5. Delivery Attempts">
          Our delivery partner will attempt to contact you upon arrival. If you are unavailable:<br/>
          • The delivery partner will wait for up to 5 minutes<br/>
          • They will attempt to call you on the registered number<br/>
          • If unreachable, the order may be marked as undelivered<br/>
          • For COD orders, the order will be returned to the vendor<br/>
          • Refunds for such cases are subject to our Refund Policy
        </Section>

        <Section title="6. Contactless Delivery">
          Quickry supports contactless delivery. You can add delivery instructions in the order notes to request items to be left at your door.
        </Section>

        <Section title="7. Damaged or Incorrect Orders">
          If you receive a damaged, incorrect, or incomplete order, please contact us within <strong style={{ color:C.text }}>1 hour of delivery</strong> at hello.quickry@gmail.com with your Order ID and photos. We will resolve the issue promptly.
        </Section>

        <Section title="8. Contact">
          <strong style={{ color:C.text }}>Email:</strong> hello.quickry@gmail.com<br/>
          <strong style={{ color:C.text }}>Support Hours:</strong> 9:00 AM – 10:00 PM IST (Monday–Sunday)<br/>
          <strong style={{ color:C.text }}>Address:</strong> Near Khandelwall School Old city Dabki Road, Akola, Maharashtra — 444001, India
        </Section>

      </div>
    </div>
  );
}